import { render, staticRenderFns } from "./CockpitLinkCard.vue?vue&type=template&id=455baa3d&scoped=true&"
import script from "./CockpitLinkCard.vue?vue&type=script&lang=js&"
export * from "./CockpitLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./CockpitLinkCard.vue?vue&type=style&index=0&id=455baa3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455baa3d",
  null
  
)

export default component.exports